import { render, staticRenderFns } from "./comments-menu.vue?vue&type=template&id=734db798&scoped=true"
import script from "./comments-menu.vue?vue&type=script&lang=js"
export * from "./comments-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734db798",
  null
  
)

export default component.exports